import Loader from "../components/basic/Loader"

const SuspenseLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Loader size="large" />
  </div>
)

export default SuspenseLoader
